import { render, staticRenderFns } from "./AdminRealEstateDevelopmentView.vue?vue&type=template&id=64b7d17b"
import script from "./AdminRealEstateDevelopmentView.vue?vue&type=script&lang=js"
export * from "./AdminRealEstateDevelopmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports